
import { showFormatedDate, showFormattedTime, showFormatedDateandTime, HELPINGHANDS } from '../../../../../actions/utilAction';
import { renderTextArea, renderTextField, renderTimePicker } from '../../../../../components/reduxFields';
import { Field, reduxForm } from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';

import { connect } from 'react-redux';
// import PatientInfo from '../../../patient_info';
import React from 'react';
import history from '../../../../../history';
import moment from 'moment';
import { getPatientEncounterNonBillable } from '../actions';

class EncounterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openSign: false,
      appointmentTypeName: '',
      appointmentDate: null,
      appointmentTime: null,
      staffName: '',
      serviceFacility: '',
      isDirectService: false,
      PatientLocationName: '',
      ClientSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      GuardianSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      SuperviseeSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      appointmentId: props.match.params.apptId,
      encounterId: props.match.params.encId,
      EmployeeSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      Signee: [],
      timeDifference: 0.0,
    };
  }
  componentWillMount() {
    let searchObj = {
      'apptId': this.state.appointmentId,
      'encounterId': this.state.encounterId,
    };
    this.props.getPatientEncounterNonBillable(searchObj);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.singleEncounter && nextProps.singleEncounter !== this.props.singleEncounter) {
      let appointmentData = nextProps.singleEncounter.patientAppointment;
      if (appointmentData) {
        let staffNames = [];
        appointmentData.appointmentSingleStaff.forEach((staff) => {
          staffNames.push(staff.staffName);
        });
        this.setState({
          appointmentTypeName: appointmentData.appointmentTypeName,
          appointmentDate: showFormatedDate(appointmentData.startDateTime),
          appointmentTime: showFormattedTime(appointmentData.startDateTime) + ' - ' + showFormattedTime(appointmentData.endDateTime),
          staffName: staffNames && staffNames ? staffNames.join(',') : '',
          serviceFacility: appointmentData.serviceFacility,
          isDirectService: appointmentData.isDirectService,
          PatientLocationName: appointmentData.address,
          timeDifference: (appointmentData.timeDifference ? (appointmentData.timeDifference / 60).toFixed(2) : 0),
        }, () => {
          if (nextProps.singleEncounter.encounterSignature) {
            (nextProps.singleEncounter.encounterSignature || []).forEach((signObj) => {
              if (signObj.clinicianSign) {
                let data = {
                  id: signObj.id,
                  Bytes: signObj.clinicianSign,
                  Date: signObj.clinicianSignDate,
                  Name: this.state.staffName,
                  Latitude: signObj.latitude, 
                  Longitude: signObj.longitude,
                };
                this.setState({ EmployeeSign: data, isAllSigned: true });
              }
              if (signObj.superviseeSign) {
                let data = {
                  id: signObj.id,
                  Bytes: signObj.superviseeSign,
                  Date: signObj.superviseeSignDate,
                  Name: signObj.superviseeName ? signObj.superviseeName : appointmentData.superviseeStaff,
                  Latitude: signObj.latitude, 
                  Longitude: signObj.longitude,
                };                
                this.setState({ SuperviseeSign: data , isAllSigned: true});
              } 
            });
          }


          // let signData = { Bytes: data.clinicianSign, Date: data.clinicianSignDate, Name: this.state.staffName };
          // this.setState({
          //   EmployeeSign: signData,
          //   isAllSigned: true,
          // });
        });
      }
      let clientSign = {
        Bytes: nextProps.singleEncounter.patientSign,
        Date: nextProps.singleEncounter.patientSignDate,
        Name: nextProps.singleEncounter.patientName,
      };
      this.setState({
        ClientSign: clientSign,
      });
    }
  }

  handleBackClick = () => {
    history.push(`/my-appointment/${this.props.singleEncounter.patientID}`);
  };

  render() {
    return (
      <div>
        <h2 className="page_title">Visit Details</h2>
        {/* <PatientInfo patientId={this.state.patientid} /> */}
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form custom_form">
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <RaisedButton className="soapmodal_btn mt-20" label="Back" primary={true} onTouchTap={this.handleBackClick} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <h3>Appointment</h3>
                    <i className="flaticon flaticon-medical-4"></i>
                  </div>
                </div>
                <div className="col-sm-12 ml-20">
                  <div className="col-sm-12 soap_content">
                    <div className="soap_detail detail_wd">
                      <p>
                        <b>Appointment :</b> <span>{this.state.appointmentTypeName ? this.state.appointmentTypeName : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Date :</b> <span>{this.state.appointmentDate ? this.state.appointmentDate : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Time:</b> <span>{this.state.appointmentTime ? this.state.appointmentTime : '-'}</span>
                      </p>
                      <p>
                        <b>Seen By :</b> <span>{this.state.staffName ? this.state.staffName : '-'}</span>
                      </p>
                      <p>
                        <b>Location Type :</b> <span>{this.state.serviceFacility || '-'}</span>
                      </p>
                      <p>
                        <b>Service Type :</b> <span>{this.state.isDirectService ? 'Direct' : 'Indirect'}</span>
                      </p>
                      <p className="wd-100">
                        <b>Service Location :</b> <span>{this.state.PatientLocationName ? this.state.PatientLocationName : '-'}</span>
                      </p>
                      <p>
                        <b>Session Duration (In Hrs):</b> <span>{this.state.timeDifference}</span>
                      </p>
                      {/* <p>
                    <b>Unit Billed :</b> <span>{totalUnitsConsumed}</span>
                  </p> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Service</h3>
                    <i className="flaticon flaticon-time-1"></i>
                  </div>
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceStartTime"
                    placeholder="Start Time"
                    disabled={true}
                    fullWidth={true}
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceStartTime}
                    onDateChange={this.onDateChange}

                  />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceEndTime"
                    placeholder="End Time"
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceEndTime}
                    onDateChange={this.onDateChange}
                    disabled={true}
                    fullWidth={true}
                  />
                </div>
              </div>
              <div className ="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Notes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
                {this.props.agencyName.toUpperCase() === HELPINGHANDS ? 
                <div className="col-sm-12">
                  <Field
                      name="trainingTitle"
                      disabled={true}
                      type="text"
                      fullWidth={true}
                      label="Training Title"
                      component={renderTextField}
                    />
                </div>:null}
                <div className={'col-sm-12 require'} >
                  <Field
                    name="NonBillableNotes"
                    type="text"
                    fullWidth={true}
                    label="Notes"
                    rows={5}
                    disabled={true}
                    autoHeight={true}
                    component={renderTextArea}
                  />
                </div>
              </div>
              { this.state.EmployeeSign.Bytes || this.state.SuperviseeSign.Bytes ?
                <div className="row">
                  <div className="col-12">
                    <div className="panel_title mt-24  mb-20">
                      <h3>Signature</h3>
                      <i className="flaticon flaticon-medical-1"></i>
                    </div>
                  </div>
                  {
                    this.state.EmployeeSign.Bytes ?
                      <div className="col-sm-12 col-md-4">
                        <div id="showCanvasImageEmployee">

                          <div className="row">
                            <div className="col-12">
                              <div className="sign">
                                <img className="img-fluid" src={`data:image/png;base64,${this.state.EmployeeSign.Bytes}`} alt={''} />
                                <h3>{this.state.EmployeeSign.Name} <span>(Employee)</span></h3>
                                <p><span>Date :</span> {showFormatedDateandTime(this.state.EmployeeSign.Date)}</p>
                                {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                                <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      : ''
                  }
                  {
                  this.state.SuperviseeSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageSupervsiee">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.SuperviseeSign.Bytes}`} alt={''} />
                              <h3>{this.state.SuperviseeSign.Name} <span>(RBT)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.SuperviseeSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
                </div>
                : ''}

            </form>
          </div>
        </div>
      </div>
    );
  }
}
EncounterForm = reduxForm({
  form: 'EncounterForm',
  enableReinitialize: true,
})(EncounterForm);
function mapStateToProps(state) {
  let initialData = {};
  let appointmentTime = null
    , encounterDetail = state.patientPortal.patientEncouterNonBillableDetail && state.patientPortal.patientEncouterNonBillableDetail.data ? state.patientPortal.patientEncouterNonBillableDetail.data : null;
  // console.log(encounterDetail);
  if (encounterDetail) {
    initialData['trainingTitle'] = encounterDetail.trainingTitle;
    initialData['NonBillableNotes'] = encounterDetail.nonBillableNotes;
    initialData['locationName'] = encounterDetail.locationName;
    initialData['staffName'] = encounterDetail.staffName;
    initialData['appointmentDate'] = encounterDetail.startDateTime;
    initialData['PatientLocationName'] = encounterDetail.PatientLocationName;
    initialData['serviceEndTime'] = moment(encounterDetail.endDateTime).format('YYYY-MM-DD') + 'T' + moment(encounterDetail.endDateTime).format('HH:mm:ss');
    initialData['serviceStartTime'] = moment(encounterDetail.startDateTime).format('YYYY-MM-DD') + 'T' + moment(encounterDetail.startDateTime).format('HH:mm:ss');

    if (encounterDetail.startDateTime) {
      let startTimehours = encounterDetail.startDateTime.substr(11, 2);
      let endTimehours = encounterDetail.endDateTime.substr(11, 2);
      let formattedStartTimehours = parseInt(startTimehours, 10) >= 12 ? (parseInt(startTimehours, 10) - 12 < 10 ? `0${parseInt(startTimehours, 10) - 12}` : startTimehours) : startTimehours;
      let formattedEndTimehours = parseInt(endTimehours, 10) >= 12 ? (parseInt(endTimehours, 10) - 12 < 10 ? `0${parseInt(endTimehours, 10) - 12}` : endTimehours) : endTimehours;

      let AmPmOfStartTime = parseInt(startTimehours, 10) >= 12 ? 'pm' : 'am';
      let AmPmOfEndTime = parseInt(endTimehours, 10) >= 12 ? 'pm' : 'am';
      appointmentTime = `${formattedStartTimehours}:${encounterDetail.startDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${encounterDetail.endDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
      initialData['appointmentTime'] = appointmentTime;
    }
  }

  return {
    singleEncounter: encounterDetail,
    initialValues: initialData,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}
export default connect(mapStateToProps, { getPatientEncounterNonBillable })(EncounterForm);



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/details/components/patient_nonBillableSoap.js